import React from 'react';
import '../../global/styles/fonts.scss';
import './Heading.scss';
import '../../global/styles/fonts.scss';

interface H1Props {
  color?: 'brand' | 'inverse';
  hidden?: boolean;
  type?:
    | 'heading-01 (60)'
    | 'heading-02 (48)'
    | 'heading-03 (36)'
    | 'heading-04 (28)';
}

interface H2Props {
  color?: 'brand' | 'inverse';
  hidden?: boolean;
  type?:
    | 'heading-02 (48)'
    | 'heading-03 (36)'
    | 'heading-04 (28)'
    | 'heading-05 (24)';
}

interface H3Props {
  color?: 'brand' | 'inverse';
  hidden?: boolean;
  type?:
    | 'heading-03 (36)'
    | 'heading-04 (28)'
    | 'heading-05 (24)'
    | 'heading-06 (20)';
}

interface H4Props {
  color?: 'brand' | 'inverse';
  hidden?: boolean;
  type?:
    | 'heading-04 (28)'
    | 'heading-05 (24)'
    | 'heading-06 (20)'
    | 'heading-07 (16)';
}

interface H5Props {
  color?: 'inverse';
  hidden?: boolean;
  type?:
    | 'heading-05 (24)'
    | 'heading-06 (20)'
    | 'heading-07 (16)'
    | 'heading-08 (14)';
}

interface H6Props {
  color?: 'brand' | 'savings' | 'danger' | 'disabled' | 'inverse';
  hidden?: boolean;
  type?: 'heading-06 (20)' | 'heading-07 (16)' | 'heading-08 (14)';
  disabled?: boolean;
}

export const H1: React.FC<H1Props> = ({
  children,
  color,
  hidden,
  type = 'heading-01 (60)'
}) => {
  return (
    <h1
      className={`
      ads-heading
      ${type === 'heading-01 (60)' ? 'ads-heading__01' : ''} 
      ${type === 'heading-02 (48)' ? 'ads-heading__02' : ''} 
      ${type === 'heading-03 (36)' ? 'ads-heading__03' : ''} 
      ${type === 'heading-04 (28)' ? 'ads-heading__04' : ''} 
      ${color === 'inverse' ? 'ads-color-inverse' : ''} 
      ${color === 'brand' ? 'ads-color-text-03' : ''} 
      ${hidden ? 'hidden' : ''}
      `}
      data-testid="ads-h1"
    >
      {children}
    </h1>
  );
};

export const H2: React.FC<H2Props> = ({
  children,
  color,
  hidden,
  type = 'heading-02 (48)'
}) => {
  return (
    <h2
      className={`
      ads-heading
      ${type === 'heading-02 (48)' ? 'ads-heading__02' : ''} 
      ${type === 'heading-03 (36)' ? 'ads-heading__03' : ''} 
      ${type === 'heading-04 (28)' ? 'ads-heading__04' : ''} 
      ${type === 'heading-05 (24)' ? 'ads-heading__05' : ''} 
      ${color === 'inverse' ? 'ads-color-inverse' : ''} 
      ${color === 'brand' ? 'ads-color-text-03' : ''} 
      ${hidden ? 'hidden' : ''}
      `}
      data-testid="ads-h2"
    >
      {children}
    </h2>
  );
};

export const H3: React.FC<H3Props> = ({
  children,
  color,
  hidden,
  type = 'heading-03 (36)'
}) => {
  return (
    <h3
      className={`
      ads-heading
      ${type === 'heading-03 (36)' ? 'ads-heading__03' : ''} 
      ${type === 'heading-04 (28)' ? 'ads-heading__04' : ''} 
      ${type === 'heading-05 (24)' ? 'ads-heading__05' : ''} 
      ${type === 'heading-06 (20)' ? 'ads-heading__06' : ''} 
      ${color === 'inverse' ? 'ads-color-inverse' : ''} 
      ${color === 'brand' ? 'ads-color-text-03' : ''} 
      ${hidden ? 'hidden' : ''}
      `}
      data-testid="ads-h3"
    >
      {children}
    </h3>
  );
};

export const H4: React.FC<H4Props> = ({
  children,
  color,
  hidden,
  type = 'heading-04 (28)'
}) => {
  return (
    <h4
      className={`
      ads-heading
      ${type === 'heading-04 (28)' ? 'ads-heading__04' : ''} 
      ${type === 'heading-05 (24)' ? 'ads-heading__05' : ''} 
      ${type === 'heading-06 (20)' ? 'ads-heading__06' : ''} 
      ${type === 'heading-07 (16)' ? 'ads-heading__07' : ''} 
      ${color === 'inverse' ? 'ads-color-inverse' : ''} 
      ${color === 'brand' ? 'ads-color-text-03' : ''} 
      ${hidden ? 'hidden' : ''}
      `}
      data-testid="ads-h4"
    >
      {children}
    </h4>
  );
};

export const H5: React.FC<H5Props> = ({
  children,
  color,
  hidden,
  type = 'heading-05 (24)'
}) => {
  return (
    <h5
      className={`
      ads-heading
      ${type === 'heading-05 (24)' ? 'ads-heading__05' : ''} 
      ${type === 'heading-06 (20)' ? 'ads-heading__06' : ''} 
      ${type === 'heading-07 (16)' ? 'ads-heading__07' : ''} 
      ${type === 'heading-08 (14)' ? 'ads-heading__08' : ''} 
      ${color === 'inverse' ? 'ads-color-inverse' : ''} 
      ${hidden ? 'hidden' : ''}
      `}
      data-testid="ads-h5"
    >
      {children}
    </h5>
  );
};

export const H6: React.FC<H6Props> = ({
  children,
  color,
  disabled,
  hidden,
  type = 'heading-06 (20)'
}) => {
  return (
    <h6
      className={`
      ads-heading
      ${type === 'heading-06 (20)' ? 'ads-heading__06' : ''} 
      ${type === 'heading-07 (16)' ? 'ads-heading__07' : ''} 
      ${type === 'heading-08 (14)' ? 'ads-heading__08' : ''} 
      ${color === 'inverse' ? 'ads-color-inverse' : ''} 
      ${color === 'brand' ? 'ads-color-text-03' : ''} 
      ${color === 'danger' ? 'ads-color-danger' : ''} 
      ${color === 'savings' ? 'ads-color-savings' : ''} 
      ${hidden ? 'hidden' : ''}
      ${disabled ? 'ads-color-disabled' : ''}
      `}
      data-testid="ads-h6"
      aria-disabled={disabled && true}
    >
      {children}
    </h6>
  );
};
